import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: 'Inter', 'Motiva Sans Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
        overflow-x: hidden;
    }

    a:hover {
        color: #2563eb;
    }

    input,
    textarea {
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        background: #f9fafb;
        transition: all 0.3s ease-in-out;
        outline: none;
        width: 100%;
        padding: 1rem 1.25rem;
        font-family: inherit;

        :focus-within {
            background: #fff;
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Inter', 'Motiva Sans Bold', serif;
        color: #0b1220;
        font-size: 52px;
        line-height: 1.1;
        letter-spacing: -0.03em;
        font-weight: 800;

        @media only screen and (max-width: 890px) {
          font-size: 42px;
        }

        @media only screen and (max-width: 414px) {
          font-size: 30px;
        }
    }

    p {
        color: #374151;
        font-size: 18px;
        line-height: 1.65;
    }

    h1 {
        font-weight: 900;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #0b1220;

        :hover {
            color: #2563eb;
        }
    }

    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
